import { KRUMAGO } from '../../../s3-assets/Krumago';



const InsightsAndEffectiveEngagement = () => {
  return (
    <section style={{ padding: '4rem 2rem', backgroundColor: '#ffffff', position: 'relative' }}>
      {/* Image and overlay */}
      <div style={{ position: 'relative', width: '100%', overflow: 'hidden', marginBottom: '4rem' }}>
        <img loading="lazy"
          src={KRUMAGO.IMAGES.INSIGHTS}
          alt="Bridging The Knowledge Gap"
          style={{
            width: '100%',
            height: 'auto',
            objectFit: 'cover',
            display: 'block'
          }}
        />
        <div style={{
          position: 'absolute',
          top: '0',
          left: '0',
          width: '50%',
          height: '100%',
          padding: '2rem',
          color: '#ffffff',
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center'
        }}>
          <div style={{
            width: '100%',
            padding: '2rem',
            boxSizing: 'border-box',
            textAlign: 'left',
          }}>
            <h2 style={{
              fontSize: '3.2rem',
              fontWeight: '700',
              color: '#455173',
              fontFamily: 'Poppins, sans-serif',
              margin: '0 0 1rem 0'
            }}>
              Insights and effective engagement
            </h2>

            <br />
            <h2 style={{
              fontSize: '1rem',
              textAlign: 'justify',
              fontWeight: '700',
              fontFamily: 'Poppins, sans-serif',
              margin: '0',
              maxWidth: '100%',
              color: '#bb4c00',
              lineHeight: '1.5'
            }}>
              At AVPS Academy, we believe that effective learning is a collaborative process between the student and the instructor. Our commitment to providing exceptional IT training is underpinned by our dedication to providing clear insights into your learning journey and fostering engaging interactions.    </h2>
          </div>

        </div>
      </div>


      {/* Content */}
      <div style={{ maxWidth: '100%', margin: '0 auto', textAlign: 'left' }}>
        <div style={{ maxWidth: '100%', margin: '0 auto', textAlign: 'left' }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem', marginBottom: '3rem' }}>
            <div style={{
              display: 'flex',
              alignItems: 'flex-start',
              flexDirection: 'column',
              maxWidth: '100%',
              margin: '0',
              textAlign: 'left'
            }}>
              <h2 style={{
                fontSize: '4rem',
                fontWeight: '700',
                color: 'var(--education-secondary, #3B9394)',
                fontFamily: 'Poppins, sans-serif',
                margin: '0'
              }}>
                How We Achieve This
              </h2>
            </div>


          </div>
        </div>


        <div style={{
          display: 'flex',
          justifyContent: 'center',
          flexWrap: 'wrap',
          gap: '2rem',
          padding: '2rem',
          boxSizing: 'border-box',
          marginBottom: '4rem'
        }}>
          {[
            'Our advanced learning management system offers real-time visibility into your course progress. You can monitor your performance, identify areas of strength and weakness, and stay motivated with every milestone achieved.',
            'We provide constructive and actionable feedback on your assignments and projects. This feedback is tailored to your individual learning style and goals, helping you improve and grow.',
            'Oe encourage open and honest communication between you and your instructors. Whether it\'s through online forums, email, or one-on-one meetings, we are always available to answer your questions and address your concerns.',
            'Our courses are designed to be engaging and interactive. Through a combination of hands-on exercises, group projects, and real-world simulations, we create a dynamic learning environment that fosters critical thinking and problem-solving skills.',
          ].map((content, index) => (
            <div key={index} style={{
              width: '100%',
              maxWidth: '300px',
              padding: '1.5rem',
              borderRadius: '12px',
              backgroundColor: '#FFFFFF',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
              transition: 'box-shadow 0.3s ease-in-out, transform 0.3s ease-in-out',
              display: 'flex',
              flexDirection: 'column',
              textAlign: 'left',
              overflow: 'hidden',
              border: '1px solid #ddd',
            }}
              onMouseOver={(e) => {
                e.currentTarget.style.boxShadow = '0 8px 16px rgba(0, 0, 0, 0.3)';
                e.currentTarget.style.transform = 'translateY(-5px)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.2)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <h3 style={{
                fontSize: '1.25rem',
                fontWeight: '600',
                color: 'var(--education-primary, #746EAC)',
                marginBottom: '1rem',
                textAlign: 'center',
                width: '100%',
              }}>
                {[
                  'Real-time Progress Tracking',
                  'Personalized Feedback',
                  'Open Communication Channels',
                  'Interactive Learning Experiences',
                ][index]}
              </h3>
              <p style={{
                fontSize: '1rem',
                color: '#555',
                lineHeight: '1.5',
                textAlign: 'justify',
                width: '100%',
              }}>
                {content}
              </p>
            </div>

          ))}
        </div>

        <div style={{
          position: 'relative',
          backgroundImage: `url(${KRUMAGO.IMAGES.HOW_IT_WORKS})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          padding: '4rem 2rem',
          color: '#FFFFFF',
          textAlign: 'center',
          marginBottom: '4rem',
        }}>
          <div style={{
            position: 'absolute',
            top: '1rem', // Adjusted to move label up
            right: '1rem',
            zIndex: '2',
            backgroundColor: '#f9f9f9',
            padding: '1rem 2rem',
            borderRadius: '8px',
            transform: 'translateY(-2rem)', // Increased to move label up further
          }}>
            <h2 style={{
              fontSize: '2.5rem',
              fontWeight: '700',
              margin: '0',
              color: 'var(--education-secondary, #3B9394)',
              textAlign: 'center'
            }}>
              The Benefits of Our Approach
            </h2>
          </div>

          <div style={{
            position: 'absolute',
            top: '0',
            left: '0',
            right: '0',
            bottom: '0',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: '1',
          }} />

          <div style={{
            position: 'relative',
            zIndex: '2',
            marginTop: '6rem' // Increased space for the content below the header
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-around',
              flexWrap: 'wrap',
              gap: '2rem',
            }}>
              <div style={{
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                padding: '2rem',
                borderRadius: '12px',
                width: '100%',
                maxWidth: '300px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                transition: 'transform 0.3s ease',
              }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}>
                <h3 style={{
                  fontSize: '1.5rem',
                  fontWeight: 'bold',
                  marginBottom: '1rem',
                  color: '#FFD700',
                }}>Improved Learning Outcomes</h3>
                <p style={{ fontSize: '1rem', color: '#FFFFFF' }}>
                  By providing clear insights and engaging interactions, we help you achieve your learning goals more effectively.
                </p>
              </div>

              <div style={{
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                padding: '2rem',
                borderRadius: '12px',
                width: '100%',
                maxWidth: '300px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                transition: 'transform 0.3s ease',
              }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}>
                <h3 style={{
                  fontSize: '1.5rem',
                  fontWeight: 'bold',
                  marginBottom: '1rem',
                  color: '#FFD700',
                }}>Enhanced Student Satisfaction</h3>
                <p style={{ fontSize: '1rem', color: '#FFFFFF' }}>
                  Our commitment to open communication and personalized support leads to higher levels of student satisfaction.
                </p>
              </div>

              <div style={{
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                padding: '2rem',
                borderRadius: '12px',
                width: '100%',
                maxWidth: '300px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                transition: 'transform 0.3s ease',
              }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}>
                <h3 style={{
                  fontSize: '1.5rem',
                  fontWeight: 'bold',
                  marginBottom: '1rem',
                  color: '#FFD700',
                }}>Stronger Student-Instructor Relationships</h3>
                <p style={{ fontSize: '1rem', color: '#FFFFFF' }}>
                  Building strong relationships with our instructors fosters a supportive and collaborative learning environment.
                </p>
              </div>

              <div style={{
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                padding: '2rem',
                borderRadius: '12px',
                width: '100%',
                maxWidth: '300px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                transition: 'transform 0.3s ease',
              }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}>
                <h3 style={{
                  fontSize: '1.5rem',
                  fontWeight: 'bold',
                  marginBottom: '1rem',
                  color: '#FFD700',
                }}>Data-Driven Curriculum Improvement</h3>
                <p style={{ fontSize: '1rem', color: '#FFFFFF' }}>
                  By analyzing student performance data, we continuously improve our courses to meet the evolving needs of the IT industry.
                </p>
              </div>
            </div>
          </div>
        </div>



        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem', marginBottom: '3rem' }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column', maxWidth: '100%', margin: '0 auto', textAlign: 'left' }}>

            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: '700',  /* Bold text */
              fontFamily: 'Poppins, sans-serif',
              margin: '0 0 0 0.5rem',
              maxWidth: '100%',
            }}>
              <span style={{ color: 'var(--education-primary, #746EAC)' }}>AVPS Academy</span> We are committed to providing you with the tools and support you need to succeed.
            </h2>


            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: '700',  /* Bold text */
              fontFamily: 'Poppins, sans-serif',
              margin: '0 auto',  /* Center the line below */
              textAlign: 'center',  /* Align text to center */
              maxWidth: '100%',
            }}>
              Let us be your partner in achieving your IT goals.
            </h2>


          </div>

        </div>
        <div style={{ textAlign: 'center' }}>

          <a href="/products" style={{
            backgroundColor: 'var(--education-primary, #746EAC)',
            color: 'white',
            padding: '1rem 2.5rem',
            borderRadius: '12px',
            textDecoration: 'none',
            display: 'inline-block',
            fontSize: '1.1rem'
          }}>Enroll Now</a>
        </div>

      </div>
    </section>
  );
};

export default InsightsAndEffectiveEngagement;